import axios from "../axios"
import {
    IOnlineDetectionEquipmentCurrentStatusData,
    IOnlineDetectionEquipmentCurrentStatusParams,
    IOnlineDetectionEquipmentData,
    IOnlineDetectionEquipmentMonitorData,
    IOnlineDetectionEquipmentMonitorParams,
    IOnlineDetectionEquipmentParams,
    IOnlineDetectionHomeData,
    IOnlineDetectionHomeParams,
    IOnlineDetectionMappingCurrentStatusData,
    IOnlineDetectionMappingCurrentStatusParams,
    IOnlineDetectionMappingData,
    IOnlineDetectionMappingListData,
    IOnlineDetectionMappingListParams
} from "./onlineDetection.types"

/**
 * 在线检测首页
 */
export function onlineDetectionHome(params: IOnlineDetectionHomeParams) {
    return axios<IOnlineDetectionHomeData>({
        method: 'get',
        url: '/onlineDetection/home',
        params
    })
}

/**
 * 在线监测-设备
 */
export function onlineDetectionEquipment(params: IOnlineDetectionEquipmentParams) {
    return axios<IOnlineDetectionEquipmentData>({
        method: 'get',
        url: '/onlineDetection/equipment',
        params,
    })
}

/**
 * 在线监测-测点
 */
export function onlineDetectionMapping(params: {
    mappingId: number
}) {
    return axios<IOnlineDetectionMappingData>({
        method: 'get',
        url: '/onlineDetection/mapping',
        params,
    })
}

/**
 * 在线监测-设备查询
 */
export function onlineDetectionMappingList(params: IOnlineDetectionMappingListParams) {
    return axios<IOnlineDetectionMappingListData>({
        method: 'get',
        url: '/onlineDetection/getOnlineMappingList',
        params
    })
}

/**
 * 在线监测-设备当前状态统计
 */
export function onlineDetectionEquipmentCurrentStatus(params: IOnlineDetectionEquipmentCurrentStatusParams) {
    return axios<IOnlineDetectionEquipmentCurrentStatusData>({
        method: 'get',
        url: '/onlineDetection/equipmentCurrentStatus',
        params,
    })
}


/**
 * 在线监测-设备
 */
export function onlineDetectionEquipmentMonitor(params: IOnlineDetectionEquipmentMonitorParams) {
    return axios<IOnlineDetectionEquipmentMonitorData>({
        method: 'get',
        url: '/onlineDetection/equipmentMonitor',
        params,
    })
}


/**
 * 在线监测-测点当前状态统计
 */
export function onlineDetectionMappingCurrentStatus(params: IOnlineDetectionMappingCurrentStatusParams) {
    return axios<IOnlineDetectionMappingCurrentStatusData>({
        method: 'get',
        url: '/onlineDetection/mappingCurrentStatus',
        params,
    })
}
